export enum ImageTableTypes {
	Product,
	ProductProperty,
	Hook,
	OrderProduct = 3
}